export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h4 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              <a id="about-fishbox-studios" className="no-underline text-white">ABOUT FISHBOX STUDIOS</a>
            </h4>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              <strong>FishBox Studios</strong> is an independent board game publisher dedicated to creating innovative and engaging tabletop experiences. We believe in the power of games to bring people together, spark creativity, and create lasting memories.
            </p>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              Our team of passionate designers and artists work tirelessly to craft games that challenge the mind and delight the senses. From strategic warfare to cooperative adventures, every <strong>FishBox Studios</strong> game is designed with care and playtested extensively to ensure the highest quality.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              We're committed to supporting our community through crowdfunding campaigns, giving backers the opportunity to be part of our creative process and receive exclusive rewards. Join us on this journey as we continue to push the boundaries of <strong>board game design</strong> and deliver unforgettable gaming experiences.
            </p>
            <div className="flex flex-wrap gap-4">
              <button 
                className="bg-orange-600 text-white px-8 py-3 rounded-md text-base font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => console.log('Navigate to Our Story')}
              >
                Our Story
              </button>
              <button 
                className="border-2 border-white text-white px-8 py-3 rounded-md text-base font-bold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Contact Us
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-4xl text-orange-500" aria-hidden="true"></i>
              </div>
              <p className="text-3xl font-bold mb-2">1</p>
              <p className="text-sm text-gray-400">Game Being Published</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-gamepad-line text-4xl text-orange-500" aria-hidden="true"></i>
              </div>
              <p className="text-3xl font-bold mb-2">More</p>
              <p className="text-sm text-gray-400">Games in Development</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-4xl text-orange-500" aria-hidden="true"></i>
              </div>
              <p className="text-3xl font-bold mb-2">1,847</p>
              <p className="text-sm text-gray-400">Community Members</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-4xl text-orange-500" aria-hidden="true"></i>
              </div>
              <p className="text-2xl font-bold mb-2">Coming Soon</p>
              <p className="text-sm text-gray-400">to Gamefound</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
